import { Box } from "@mui/system";
import React from "react";
import { SectionHeader } from "./SectionHeader";
import GenericBarGraph from "@/components/Graph/GenericBarGraph";
import type { TaskMetricsProps } from "@/types/dashboardtypes";

export default function TaskMetrics(props: TaskMetricsProps) {
  const {
    visitFormLabels,
    visitFormDatasets,
    taskStatusLabels,
    taskStatusDatasets,
    overdueTaskLabels,
    overdueTaskDatasets,
    archivedTaskLabels,
    archivedTaskDatasets,
    singleColumn,
  } = props;

  return (
    <Box sx={{ mt: 3, borderRadius: 2, overflow: "hidden", boxShadow: 1 }}>
      {/* Header */}
      <SectionHeader title="Forms & Task Metrics" />

      {/* Content */}
      <Box
        sx={{
          bgcolor: "#fff",
          p: 2,
          display: "grid",
          gridTemplateColumns: singleColumn ? "1fr" : "1fr 1fr",
          gap: 3,
          alignItems: "flex-start",
        }}
      >
        {/* Visit Form */}
        <GenericBarGraph
          labels={visitFormLabels}
          datasets={visitFormDatasets}
          title="Visit Form - Dynamic Form Count"
        />

        {/* Task Status */}
        <GenericBarGraph
          labels={taskStatusLabels}
          datasets={taskStatusDatasets}
          title="Task Status"
        />

        {/* Task Overdue */}
        <GenericBarGraph
          labels={overdueTaskLabels}
          datasets={overdueTaskDatasets}
          title="Overdue Tasks"
        />

        {/* Task Archived */}
        <GenericBarGraph
          labels={archivedTaskLabels}
          datasets={archivedTaskDatasets}
          title="Archived vs Current Tasks"
        />
      </Box>
    </Box>
  );
}
